<nav aria-label="Page navigation" class="d-inline-block">
    <div class="pagination btn-group">
        @for (page of pageList; track page) {
            <button
                kui-button
                [class.active]="page.active"
                [color]="page.active ? 'primary' : 'secondary'"
                class="page-item page-link"
                (click)="changePage(page.index)"
                [attr.aria-label]="page.text"
            >
                @if (page.text === "Previous") {
                    <span aria-hidden="true"
                        ><span><kui-icon name="chevron-left"></kui-icon></span
                    ></span>
                }
                @if (page.text === "Next") {
                    <span aria-hidden="true"
                        ><span><kui-icon name="chevron-right"></kui-icon></span
                    ></span>
                }
                <span [class.sr-only]="page.text === 'Previous' || page.text === 'Next'">{{ page.text }}</span>
            </button>
        }
    </div>
</nav>
